module.exports = __webpack_public_path__ + "img/info-button.8b975d4e.svg";